import { Button } from "@newsela/angelou";
import { useRouter } from "next/router";

import {
  actionPrefixes,
  objectTypes,
  withTrackEvent,
  actionNames,
} from "@newsela/snitch";
import { Assignment } from "@/types/models/Assignment.interface";
import useAssignmentReducerContext from "@/view/utils/useAssignmentReducerContext";
import { cancelButtonCss } from "./AssignmentsDeleteCancelButton.style";

interface DeleteCancelButton {
  closeDeleteModal: () => void;
}

const ButtonWithTrackEvent = withTrackEvent(
  Button,
) as React.ForwardRefExoticComponent<
  React.ComponentProps<typeof Button> & React.RefAttributes<HTMLButtonElement>
>;

const AssignmentDeleteCancelButton = ({
  closeDeleteModal,
}: DeleteCancelButton) => {
  const router = useRouter();
  const { query } = router;
  const contentId = query?.["levelId"];

  const { updatedAssignment } = useAssignmentReducerContext() as {
    updatedAssignment: Pick<Assignment, "assignment_members" | "content_id">;
  };

  const assignmentMembers = updatedAssignment?.assignment_members;

  const eventProperties = {
    objectType: objectTypes.assignment,
    actionName: actionNames.delete,
    actionPrefix: actionPrefixes.cancel,
    streamProperties: {
      content_id: contentId,
      object_id: updatedAssignment?.content_id,
      content_type: "Article",
      content_ids: assignmentMembers?.map((member) =>
        "content" in member ? member.content.content_id : member.content_id,
      ),
      description: "Cancel deleting assignment.",
    },
  };

  return (
    <ButtonWithTrackEvent
      __cssFor={{ root: cancelButtonCss }}
      dataProps={{
        "data-qa-selector": "modal-cancel-delete-assignment-button",
      }}
      flavor={Button.flavors.tertiary}
      onClick={closeDeleteModal}
      {...eventProperties}
    >
      Cancel
    </ButtonWithTrackEvent>
  );
};

export default AssignmentDeleteCancelButton;
